import React from 'react';
import { Grid, Box } from '@mui/material';
import FilterBar from './filterBar';
import MatchRates from './matchRates';
import Demographics from './demographics';

function PhysicianAnalysis() {
    return (
        <Box >
            <FilterBar />
            <Box id="target-list-analysis-report">
                {/* Physician Analysis Info */}
                <Grid item xs={12} >
                    <MatchRates />
                </Grid>
                <Grid item xs={12}>
                    <Demographics />
                </Grid>
            </Box>
        </Box>
    )
}

export default PhysicianAnalysis;